export const readClipboardSafely = async (): Promise<ClipboardItems | Error> => {
  try {
    return await navigator.clipboard.read();
  } catch (maybeError) {
    const err = maybeError instanceof Error ? maybeError : new Error(String(maybeError));
    return err;
  }
};
